import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import locales from 'scratch-l10n';
import styles from './language-selector.css';

// supported languages to exclude from the menu, but allow as a URL option
const ignore = ['ab', 'am', 'az', 'id', 'be', 'bg', 'ca', 'cs', 'cy', 'da', 'et',
    'el', 'it', 'es-419', 'eu', 'fa', 'ga', 'gd', 'gl', 'ko', 'he', 'hr', 'zu', 'is',
    'ka', 'sw', 'ht', 'ckb', 'lv', 'lt', 'hu', 'mi', 'nl', 'ja-Hira', 'nb', 'nn', 'uz', 'th',
    'km', 'pl', 'pt-br', 'rap', 'ro', 'sr', 'sk', 'sl', 'fi', 'sv', 'vi', 'tr', 'uk'];

// 简体
// 繁体
// 阿拉伯
// 西班牙
// 英语

// es : 西班牙
// ar: 阿拉伯
// en : 英语
// zh-cn: 简体
// zh-tw: 繁体
// ru : 俄语
// pt ：葡萄牙
// ja : 日本语
// fr ：法语
// de : 德语

const LanguageSelector = ({ currentLocale, label, onChange, languageMenuOpen }) => (
    // <select
    //     aria-label={label}
    //     className={styles.languageSelect}
    //     value={currentLocale}
    //     onChange={onChange}
    // >
    //     {
    //         Object.keys(locales)
    //             .filter(l => !ignore.includes(l))
    //             .map(locale => (
    //                 <option
    //                     key={locale}
    //                     value={locale}
    //                 >
    //                     {locales[locale].name}
    //                 </option>
    //             ))
    //     }
    // </select>
    <div className={classNames(styles.localesBox, { [styles.isOpen]: languageMenuOpen })}>
        <ul className={styles.list}>
            {
                Object.keys(locales)
                    .filter(l => !ignore.includes(l))
                    .map(locale => (
                        <li
                            className={classNames(styles.listItem, { [styles.selectItem]: currentLocale == locale })}
                            key={locale}
                            data-value={locale}
                            onClick={onChange}
                        >
                            {locales[locale].name}
                        </li>
                    ))
            }
        </ul>
    </div>
);

LanguageSelector.propTypes = {
    currentLocale: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func
};

export default LanguageSelector;
